/*
Composant affichage global:
- pour le message de chargement
- pour l'affichage des toasts
*/
<template>
    <div v-if="dialogStore.logoutModal" class="hqmodal-backdrop"></div>
    <div v-if="dialogStore.logoutModal" class="logout-modal">
        <div class="hqmodal" tabindex="-1" :style="{ 'height': '80%', 'width': '80%' }">


            <div class="hqmodal-header alert-msg">
                <h5 class=" hqmodal-title alert-msg">Déconnexion</h5>

            </div>
            <div class="hqmodal-body">
                Vous avez été déconnecté, veuillez fermer le navigateur

            </div>




        </div>
    </div>

    <div v-if="isLoading" class="loader-container">
        <div class="loader-message-container">
            <div class="loader-spinner" style="padding-top: 30px;padding-left: 30px;">
                <Loader :size="'large'" :type="'converging-spinner'"></Loader>
            </div>
            <div class="loader-text">{{ dialogStore.loaderMsg }}</div>
        </div>
        <div class="loader-overlay">
        </div>
    </div>

    <NotificationGroup :style="{ top: '100px', left: '50%', transform: 'translateX(-50%)' }">
        <Fade :appear="dialogStore.isToastVisible">
            <Notification v-if="dialogStore.isToastVisible" :closable="dialogStore.toastClosable"
                :type="{ style: dialogStore.toastType, icon: true }" @close="dialogStore.isToastVisible = false">
                <span>{{ dialogStore.toastMessage }}</span>
            </Notification>
        </Fade>
    </NotificationGroup>

    <kdialog v-if="showDialog" :title="i18n.t('ressources.attention')" @close="toggleAlertMsgDialog" class="alert-msg">
        <div class="alertMsgDialogText">
            {{ props.alertMsgDialogText }}
        </div>
        <kdialogbar>
            <kbutton :theme-color="'error'" @click='handleResolve(true)'>{{
                props.alertMsgOkBtnText
            }}</kbutton>
            <kbutton @click='handleResolve(false)'>{{ i18n.t('ressources.cancel') }}</kbutton>
        </kdialogbar>
    </kdialog>
</template>

<script setup lang="ts">

import { useDialogStore } from "../../stores/dialog"
//  import { ref } from "vue";
import { Loader } from "@progress/kendo-vue-indicators";
import { Notification, NotificationGroup } from '@progress/kendo-vue-notification';
import { Dialog as kdialog, DialogActionsBar as kdialogbar } from '@progress/kendo-vue-dialogs';
import { Button as kbutton } from '@progress/kendo-vue-buttons';
import { inject, ref } from 'vue';
//Module de langues
const i18n: any = inject("i18n");
//Cache le message de chargement au départ
import { storeToRefs } from 'pinia'
const dialogStore = useDialogStore();
const { isLoading } = storeToRefs(dialogStore);
type PromiseResolver = (value: boolean) => void;

const resolvePromise = ref<PromiseResolver | null>(null);
const rejectPromise = ref<PromiseResolver | null>(null);
const showDialog = ref(false);


const handleResolve = (value: boolean) => {
    if (resolvePromise.value) {
        resolvePromise.value(value);
    }
};

/**
 * Affiche ou cache le modal de message alerte
 */
function toggleAlertMsgDialog() {
    showDialog.value = !showDialog.value;
}

function show(): Promise<boolean> {
    return new Promise((resolve, reject) => {
        showDialog.value = true;
        resolvePromise.value = resolve;
        rejectPromise.value = reject;
    });
};

function showStickyToast(): Promise<boolean> {
    return new Promise((resolve, reject) => {
        dialogStore.isToastVisible = true;
        resolvePromise.value = resolve;
        rejectPromise.value = reject;
    });
};



const props = defineProps({
    alertMsgDialogText: String,
    alertMsgOkBtnText: String,
})

defineExpose({
    show,
    handleResolve,
    toggleAlertMsgDialog,
    showStickyToast
});



</script>

<style lang="less" scoped>
@import "./DialogCenter.less";
</style>